/**
 * Alaska Gift — Header
 * Mobile menu toggle, focus trap, Escape key, and desktop dropdown keyboard support.
 * Depends on: global.js (AlaskaUtils)
 */

(() => {
  /* ── Mobile menu ── */
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.getElementById('mobile-menu');
  if (!toggle || !menu) return;

  function openMobileMenu() {
    menu.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mobile-menu-open');
    AlaskaUtils.trapFocus(menu);
    menu.querySelector('a')?.focus();
  }

  function closeMobileMenu() {
    menu.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mobile-menu-open');
    AlaskaUtils.removeTrapFocus(menu);
    toggle.focus();
  }

  toggle.addEventListener('click', () => {
    const isOpen = menu.classList.contains('is-open');
    if (isOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  // Close menu when clicking a link
  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMobileMenu);
  });

  // Close menu on Escape
  menu.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileMenu();
    }
  });

  /* ── Desktop dropdown keyboard support ── */
  const dropdownTrigger = document.querySelector('[data-dropdown-trigger]');
  const dropdownMenu = dropdownTrigger?.closest('.header__dropdown')?.querySelector('.header__dropdown-menu');
  if (dropdownTrigger && dropdownMenu) {
    function openDropdown() {
      dropdownTrigger.setAttribute('aria-expanded', 'true');
      dropdownMenu.classList.add('is-open');
      dropdownMenu.setAttribute('aria-hidden', 'false');
    }
    function closeDropdown() {
      dropdownTrigger.setAttribute('aria-expanded', 'false');
      dropdownMenu.classList.remove('is-open');
      dropdownMenu.setAttribute('aria-hidden', 'true');
    }

    dropdownTrigger.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        openDropdown();
        dropdownMenu.querySelector('a')?.focus();
      }
    });

    dropdownMenu.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeDropdown();
        dropdownTrigger.focus();
      }
    });

    document.addEventListener('focusin', (e) => {
      if (!dropdownTrigger.closest('.header__dropdown').contains(e.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('click', (e) => {
      if (!dropdownTrigger.closest('.header__dropdown').contains(e.target)) {
        closeDropdown();
      }
    });
  }
})();
